import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";

export const QuoteSection = () => {
  const { translations: t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <section className="py-16 md:py-20 bg-[#C4956A]" ref={ref}>
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <p className="text-xl md:text-2xl lg:text-3xl text-white font-medium leading-relaxed mb-6">
            {t.quote.text}
          </p>
          <footer className="text-white/80">
            {t.quote.author}
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
};
